const profileTypes = Object.freeze({
  MASTER: { name: 'master', id: '-1' },
  ADMIN: { name: 'admin', id: '1' },
  OPERATOR: { name: 'operator', id: '2' },
  SUPERVISOR: { name: 'supervisor', id: '3' },
  TECHNICIAN: { name: 'technician', id: '4' },
  INTERESTED: { name: 'interested', id: '5' },
});

export { profileTypes };
